var exports = {
  "Gp": "xaf9ae18d--a3b9ae--navigation-btn",
  "kc": "xaf9ae18d--a3b9ae--listing-btn",
  "wu": "xaf9ae18d--a3b9ae--listing-btn--mobile",
  "kz": "xaf9ae18d--a3b9ae--listing-title",
  "ye": "xaf9ae18d--a3b9ae--listing-title--mobile",
  "wG": "xaf9ae18d--a3b9ae--loader",
  "DD": "xaf9ae18d--a3b9ae--title",
};

module.exports = exports;
